import { Link as LinkNative } from 'react-router-dom'
import {
  IconButton,
  ImageList,
  ImageListItem,
  useTheme,
  ImageListItemBar,
  Link,
  useMediaQuery,
} from '@mui/material'
import ControlPoint from '@mui/icons-material/ControlPoint'

import { ISetStockImage, IStockImageDto } from 'src/types'
import { useStyles } from './styles'
import { PEXELS_URL } from 'src/constants'

interface IProps {
  items: IStockImageDto[]
  setImage: ISetStockImage
}

export const ItemsList = ({ items, setImage }: IProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleImageChoose = (img: string) => () => {
    setImage(img)
  }

  return (
    <div className={classes.imageListWrapper}>
      <ImageList className={classes.imagesList} cols={isTablet ? 1 : 2}>
        {items.map((item) => (
          <ImageListItem className={classes.imageItem} cols={isTablet ? 2 : 1} key={item.id}>
            <img src={item.src.large} alt={item.alt} className={classes.image} loading="lazy" />
            <ImageListItemBar
              classes={{ actionIcon: classes.imageActionBtnWrapper }}
              title={item.alt}
              subtitle={
                <span>
                  Photo by&nbsp;
                  <Link to={item.photographer_url} target="_blank" component={LinkNative}>
                    {item.photographer}
                  </Link>
                  &nbsp;on&nbsp;
                  <Link to={PEXELS_URL} target="_blank" component={LinkNative}>
                    Pexels
                  </Link>
                </span>
              }
              actionIcon={
                <IconButton onClick={handleImageChoose(item.src.original)}>
                  <ControlPoint color="primary" />
                </IconButton>
              }
              position="below"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  )
}
